var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 720,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1280,
    height: 720,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 482.817 0C681.74 0 843 161.178 843 360 843 558.822 681.74 720 482.817 720L0 720Z",
    fill: "#0068FF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 379 0C169.684 0 0 169.684 0 379L0 0Z",
    fill: "#44546A",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 1280 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0C0 209.316 169.684 379 379 379L0 379 0 0Z",
    fill: "#44546A",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 1280 341)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdms);
export default __webpack_public_path__ + "static/media/ADMS.305677456450f3e361d097c4bd38c8c7.svg";
export { ForwardRef as ReactComponent };